// src/client/components/Button.tsx
// Mobile-first CTA: gradient primary with 14px radius (per CLAUDE.md UI rules).
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md' | 'lg';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  loading?: boolean;
  block?: boolean;
}

export default function Button({
  variant = 'primary', size = 'md', leftIcon, rightIcon, loading, block,
  children, className, disabled, type, ...rest
}: Props) {
  const cls = [
    styles.btn, styles[variant], styles[size], block && styles.block, className,
  ].filter(Boolean).join(' ');
  return (
    <button
      {...rest}
      type={type ?? 'button'}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cls}
    >
      {leftIcon && <span className={styles.icon}>{leftIcon}</span>}
      <span>{loading ? 'Working…' : children}</span>
      {rightIcon && <span className={styles.icon}>{rightIcon}</span>}
    </button>
  );
}
